"use strict";

window.RightToWorkAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.getBaseAPI());

    self.getRightToWorkSettings = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required ";
        }

        _protected.request('brands/' + brandId + '/right_to_work/settings', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data['status_code'] === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.hasGeneric = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required ";
        }

        _protected.request('brands/' + brandId + '/right_to_work/has_generic', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data['status_code'] === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
};

RightToWorkAPI.COUNTRY_TYPES = {
    UK: "UK",
    GENERIC: "GENERIC",
    ROI: 'ROI',
};